// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - OpenseaAuthWalletVerificationRequest
 * OpenseaAuthWalletVerificationRequest
 */
@model({name: 'OpenseaAuthWalletVerificationRequest'})
export class OpenseaAuthWalletVerificationRequest {
  constructor(data?: Partial<OpenseaAuthWalletVerificationRequest>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  id?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  address?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  accountId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
  })
  metadata?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [additionalProperty: string]: any;
  };

  /**
   * A flag to verify the wallet without saving it
   */
  @property({
    jsonSchema: {
      type: 'boolean',
      description: 'A flag to verify the wallet without saving it',
    },
  })
  verifyOnly?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  proxyType?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  walletType?: string;

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  signInState: string;
}

export interface OpenseaAuthWalletVerificationRequestRelations {
  // describe navigational properties here
}

export type OpenseaAuthWalletVerificationRequestWithRelations =
  OpenseaAuthWalletVerificationRequest &
    OpenseaAuthWalletVerificationRequestRelations;
